import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import {MainService} from './main.service';
@Injectable({
  providedIn: 'root'
})
export class ProdcutsService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl + '/portal';
  }
  async addProducts(obj :any) {
    const resp = await this.http.post<any>(this.httpUrl + '/addProducts', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async removeProduct(obj :any) {
    const resp = await this.http.delete<any>(this.httpUrl + '/removeProduct'+JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
}
